const LIMITS_ERROR_MESSAGES = {
  updateLimitsError:
    "Limits have just been edited by another user so your changes weren't saved. You need to set your limits again, sorry!",
};

export default LIMITS_ERROR_MESSAGES;
